import { DialogTitle } from '@mui/material';

export const VerdictInputDialogTitle = () => <DialogTitle>Saisir l'avis de la demande</DialogTitle>;
